<!-- THIS IS THE NEW GENERIC POPUP THAT SHOULD REPLACE ALL THE OTHER POPUPS -->

<div class="backdrop"></div>
<div class="popup-standard limit-width-on-desktop-float" [ngClass]="{'add-top': sharedConfig.popupNeedsToScroll}">
  <!-- Close button for the popup -->
  <div class="close-popup" *ngIf="sharedConfig.popupDialogButtonTopCloseShow" (click)="closePopup()">
    <p>X</p>
  </div>
  <div class="text-center" style="margin-bottom: 15px;">
    <h2 class="h2-bold" style="color: black">{{ sharedConfig.popupDialogHeader }}</h2>
  </div>
  <div class="sub-header">
    <p style="color: black">{{ sharedConfig.popupDialogSubHeader }}</p>
  </div>
  <img
    *ngIf="sharedConfig.popupDialogImageUrl && (sharedConfig.isRecording || sharedConfig.isProcessing)"
    [src]="sharedConfig.popupDialogImageUrl"
    alt="image"
    style="display: block; width: 100%; height: 200px"
  />

  <ion-list *ngIf="sharedConfig.popupDialogTextAreaPlaceholder && !sharedConfig.isRecording && !sharedConfig.isProcessing">
    <div class="input-section">
      <ion-item mode="ios">
        <ion-input autofocus="true" (keydown)="nextOnEnter($event)" type="textarea" (ionInput)="onTextAreaChange($event)"></ion-input>
      </ion-item>
    </div>
  </ion-list>

  <!-- <ion-button
    *ngIf="!sharedConfig.isRecording && sharedConfig.popupDialogButtonThreeText && !sharedConfig.isProcessing"
    (click)="buttonThreeAction()"
    style="padding-bottom: 40px"
    mode="ios"
    class="secondary-button button-record"
  >
    <ion-icon slot="icon-only" src="assets/icon/toolbar-icons/lyrics-microphone-music-svgrepo-com.svg" size="small"></ion-icon>
    <small> {{ sharedConfig.popupDialogButtonThreeText }}</small>
  </ion-button> -->

  <div style="padding-bottom: 40px" style="text-align: center; margin: 15px 0">
    <label style="color: black"> {{ sharedConfig.popupDialogTextAreaResultsValue }}</label>
  </div>

  <div class="buttons-wrapper">
    <div *ngIf="sharedConfig.popupDialogShowThreeButtons">
      <ion-button mode="ios" class="secondary-button mt-4" (click)="buttonOneAction()">{{ sharedConfig.popupDialogButtonOneText }} </ion-button>
      <ion-button mode="ios" class="secondary-button mt-4" (click)="buttonTwoAction()">{{ sharedConfig.popupDialogButtonTwoText }}</ion-button>
      <ion-button mode="ios" class="primary-button mt-25" (click)="buttonThreeAction()">{{ sharedConfig.popupDialogButtonThreeText }}</ion-button>
    </div>
    <div *ngIf="sharedConfig.popupDialogContactCard">
      <div *ngIf="sharedConfig.userPermissions?.intercom" (click)="openIntercom()" class="button-style-wrapper">
        Chat in app
      </div>
      <div *ngIf="sharedConfig.userPermissions?.use_whatsapp_widget && this.sharedConfig.user.broker.whatsapp_number && this.sharedConfig.user.broker.whatsapp_number.length > 2" (click)="openWhatsApp()" class="button-style-wrapper">
        Chat in Whatsapp
      </div>
      <div
        *ngIf="sharedConfig.userPermissions?.phone_broker"
        (click)="callBroker()" class="button-style-wrapper">
        Contact Broker
      </div>
      <div *ngIf="sharedConfig.userPermissions?.phone_insurer">
        <div *ngFor="let insurer of sharedConfig.appClientDetail?.insurer_contact_details" class="button-style-wrapper"
          (click)="callInsurer(insurer)">
          Call {{ insurer.description }}
        </div>
      </div>
      <div *ngIf="!sharedConfig.userPermissions?.intercom" >
        <a href={{href_string}}>
          <div class="button-style-wrapper">
            Technical Support
          </div>
        </a> 
      </div>
        <ion-button mode="ios" class="primary-button mt-4" (click)="closePopup()">Close</ion-button>
    </div>
    <div *ngIf="sharedConfig.popupDialogShowCallInsurer">
      <div *ngFor="let insurer of sharedConfig.appClientDetail?.insurer_contact_details" class="button-style-wrapper" (click)="callInsurer(insurer)">
        {{ insurer.description }}
      </div>
      <ion-button mode="ios" class="primary-button mt-4" (click)="closePopup()">Close</ion-button>
    </div>
    <div *ngIf="!sharedConfig.popupDialogShowThreeButtons && !sharedConfig.popupDialogShowCallInsurer">
      <ion-button *ngIf="sharedConfig.popupDialogButtonOneText" mode="ios" class="primary-button" (click)="buttonOneAction()">{{
        sharedConfig.popupDialogButtonOneText
      }}</ion-button>
      <ion-button *ngIf="sharedConfig.popupDialogButtonTwoText" mode="ios" class="secondary-button" (click)="buttonTwoAction()">
        {{ sharedConfig.popupDialogButtonTwoText }}
      </ion-button>
    </div>
  </div>
</div>
